<div class="ai-action-card" [class.ai-action-card--resolved]="isResolved">
  <div class="ai-action-card__head">
    <i class="pi pi-bolt"></i>
    <div class="ai-action-card__headings">
      <span class="ai-action-card__name" *ngIf="leadName">{{ leadName }}</span>
      <span class="ai-action-card__tool">{{ action?.summary || 'Confirm action' }}</span>
    </div>
    <span class="ai-action-card__queue" *ngIf="queuedRemaining > 0" [title]="queuedRemaining + ' more to confirm after this'">
      +{{ queuedRemaining }}
    </span>
  </div>

  <ul class="ai-action-card__args" *ngIf="rows.length">
    <li *ngFor="let row of rows">
      <span class="ai-action-card__label">{{ row.label }}</span>
      <span class="ai-action-card__value">{{ row.value }}</span>
    </li>
  </ul>

  <!-- Bulk confirmation: the records this single Confirm will affect -->
  <div class="ai-action-card__bulk" *ngIf="bulkItemNames.length">
    <span class="ai-action-card__chip" *ngFor="let name of bulkItemNames">{{ name }}</span>
  </div>

  <!-- Editable dropdowns: backend-supplied (create_lead) + frontend tag-built (status / reason) -->
  <div class="ai-action-card__fields" *ngIf="editableDropdowns.length && !isResolved">
    <div class="ai-action-card__field" *ngFor="let dd of editableDropdowns">
      <label class="ai-action-card__field-label">
        {{ dd.label }}<span class="ai-action-card__req" *ngIf="dd.required" aria-hidden="true">*</span>
      </label>
      <ng-select
        class="ai-action-card__select"
        [items]="dd.options"
        [searchable]="true"
        [clearable]="!dd.required"
        [placeholder]="'Select ' + (dd.label | lowercase) + '…'"
        [disabled]="isBusy"
        [(ngModel)]="selected[dd.field]"></ng-select>
    </div>
  </div>

  <!-- Action buttons while awaiting a decision -->
  <div class="ai-action-card__actions" *ngIf="!isResolved">
    <button type="button" class="ai-btn ai-btn--ghost" (click)="cancel.emit()" [disabled]="isBusy">Cancel</button>
    <button type="button" class="ai-btn ai-btn--primary" (click)="onConfirm()" [disabled]="isBusy || !canConfirm">
      <i class="pi pi-spin pi-spinner" *ngIf="state === 'confirming'"></i>
      <span>{{ state === 'confirming' ? 'Working…' : 'Confirm' }}</span>
    </button>
  </div>

  <!-- Terminal states -->
  <div class="ai-action-card__status" *ngIf="isResolved">
    <span *ngIf="state === 'confirmed'" class="ai-action-card__status--ok"><i class="pi pi-check-circle"></i> Confirmed</span>
    <span *ngIf="state === 'cancelled'" class="ai-action-card__status--muted"><i class="pi pi-times-circle"></i> Cancelled</span>
    <span *ngIf="state === 'failed'" class="ai-action-card__status--error"><i class="pi pi-exclamation-circle"></i> Couldn’t complete</span>
  </div>
</div>
